import { CheckCircle2, Info } from "lucide-react";

/**
 * The amber out-of-date line under the Help header (epic PI-SPEC-SW-E302,
 * feature PI-SPEC-SW-1557, frame H6, design `.warnbar`): the bundled help
 * pack describes an older SpecTree than this server runs. Once shown it stays
 * for the whole conversation (the bridge hook latches it).
 */
export function HelpOutOfDateNotice({
  packVersion,
  serverVersion,
}: {
  packVersion: string | undefined;
  serverVersion: string | undefined;
}) {
  const text =
    packVersion && serverVersion
      ? `Help's notes describe SpecTree ${packVersion}; this server runs ${serverVersion}. Some screens may have changed since.`
      : "Help's notes describe an older SpecTree than this server runs. Some screens may have changed since.";
  return (
    <div
      role="status"
      className="flex flex-none items-start gap-2 border-b border-[rgba(245,158,11,0.25)] bg-[rgba(245,158,11,0.08)] px-4 py-2 text-xs leading-[1.45] text-[#FDE68A]"
      data-testid="help-out-of-date"
    >
      <Info className="mt-px h-3.5 w-3.5 flex-none" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}

/**
 * The green line under the Help header once Help is ready again after Claude
 * was signed out (SpecTree Windows walk 1, gap G-03): "Signed in — Help is
 * ready". It stays until the next question or a new conversation.
 */
export function HelpReadyNotice({ text }: { text: string }) {
  return (
    <div
      role="status"
      className="flex flex-none items-start gap-2 border-b border-[rgba(34,197,94,0.25)] bg-[rgba(34,197,94,0.08)] px-4 py-2 text-xs leading-[1.45] text-[#86EFAC]"
      data-testid="help-ready-notice"
    >
      <CheckCircle2 className="mt-px h-3.5 w-3.5 flex-none" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
